import { average } from './average';
import { historical } from './historical';
import { statistics } from './statistics';

export const v1 = {
  average,
  historical,
  statistics,
};
